import { requestPrescription_patient_exemptions as PatientExemptions } from "../graphql/types/requestPrescription";
import { ExemptionStatus } from "../graphql/types/global";
import { formatPrice } from "./price";

export const getMostRecentExemption = (
  exemptions: PatientExemptions[],
  exemptionStatus: ExemptionStatus
): PatientExemptions => {
  const currentDate = new Date().getTime() / 1000;

  return exemptions
    .filter(exemption => {
      return (
        exemption.status === exemptionStatus &&
        (exemption.expiry === null || exemption.expiry.seconds > currentDate)
      );
    })
    .sort((a, b) => {
      return b.created.seconds - a.created.seconds;
    })[0];
};

export const getPriceAsString = (price: number) => {
  if (price === 0) {
    return "Free";
  }
  return formatPrice(price);
};

/**
 * "It picks a random element for each original array element, and excludes it from the next draw,
 * like picking randomly from a deck of cards.
 *
 * This clever exclusion swaps the picked element with the current one, then picks the next random
 * element from the remainder, looping backwards for optimal efficiency, ensuring the random pick
 * is simplified (it can always start at 0), and thereby skipping the final element."
 * - https://stackoverflow.com/a/12646864 ¯\_(ツ)_/¯
 */
export const shuffle = <T>(array: T[]) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
};
